<template>
  <el-form ref="courseForm" :model="form" :rules="rules" label-width="120px" class="demo-ruleForm t_center"
           align="left">
    <el-form-item label="课程名称:" prop="courseName">
      <el-input v-model="form.courseName" placeholder="课程名称" @input="searchCommodityinfoByAll" ></el-input>
    </el-form-item>
    <el-form-item label="课程英文名称:" prop="courseEnglishName" v-if="loginOrgCode == 'blcuonline'">
      <el-input v-model="form.courseEnglishName" placeholder="课程名称" @input="searchCommodityinfoByAll" ></el-input>
    </el-form-item>
    <el-form-item label="主营类目:" :inline="true"  prop="ccId" style="width: 100%" v-if="loginOrgCode != 'blcuonline'">
      <el-cascader
          expand-trigger="hover"
          :options="categoryOptions"
          v-model="selectedCategory"
          :props="{ value: 'ccId', label: 'ccName'}"
          @change="changeCategory">
      </el-cascader>
    </el-form-item>
    <el-form-item label="特色介绍:" prop="introduce">
      <el-input v-model="form.introduce" placeholder="特色介绍"></el-input>
    </el-form-item>
    <el-form-item label="英文特色介绍:" prop="englishIntroduce" v-if="loginOrgCode == 'blcuonline'">
      <el-input v-model="form.englishIntroduce" placeholder="特色介绍"></el-input>
    </el-form-item>
    <el-form-item label="商品型号:" prop="price">
      <el-radio v-model="form.modelType" :label="1">统一型号</el-radio>
      <el-radio v-model="form.modelType" :label="2">多级型号</el-radio>
    </el-form-item>
    <commodityModel></commodityModel>
    <el-form-item label="原价:" prop="price">
      <el-input v-model="form.price" placeholder="原价"></el-input>
    </el-form-item>
    <el-form-item label="优惠价:" prop="preferential">
      <el-input v-model="form.preferential" placeholder="优惠价"></el-input>
    </el-form-item>
    <el-form-item label="优惠截止时间:" prop="preferentialEndTime" v-if="loginOrgCode == 'blcuonline'">
      <el-date-picker
          v-model="form.preferentialEndTime"
          type="datetime"
          placeholder="选择日期">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="课时标准:" prop="standard">
      <el-input v-model="form.standard" placeholder="课时标准"></el-input>
    </el-form-item>
    <el-form-item label="购买人数:" prop="persionNum">
      <el-input v-model="form.persionNum" placeholder="购买人数"></el-input>
    </el-form-item>
    <el-form-item label="课时:" prop="classTime">
      <el-input v-model="form.classTime" placeholder="课时"></el-input>
    </el-form-item>
    <el-form-item label="有效期:" prop="validity">
      <el-radio v-model="form.validityType" :label="1" @change="changeValidityType">永久</el-radio>
      <el-radio v-model="form.validityType" :label="2" @change="changeValidityType">
              <span class="input_">
                <el-input  v-model="form.validity" @input="checkValidity"  placeholder="有效期" >
                    <template slot="append">天</template>
                </el-input>
              </span>
      </el-radio>
    </el-form-item>
    <el-form-item label="开班日期:" prop="openClassTime">
      <el-radio v-model="form.openClassType" :label="1" @change="changeOpenClass">随时</el-radio>
      <el-radio v-model="form.openClassType" :label="2" @change="changeOpenClass">
        <el-date-picker
            v-model="form.openClassTime"
            type="date"
            @change="changeOpenClass"
            placeholder="选择日期">
        </el-date-picker>
      </el-radio>
    </el-form-item>
    <el-form-item label="授课类型:" prop="lessonType" v-if="loginOrgCode != 'blcuonline'">
      <el-select placeholder="" size="small" v-model="form.lessonType">
        <el-option label="直播" :value="1"></el-option>
        <el-option label="面授" :value="2"></el-option>
        <el-option label="录播" :value="3"></el-option>
        <el-option label="录播+直播" :value="4"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="汉语水平:"  v-if="loginOrgCode == 'blcuonline'">
      <el-select placeholder="" size="small" v-model="form.lessonType">
        <el-option label="入门" :value="11"></el-option>
        <el-option label="初级" :value="12"></el-option>
        <el-option label="中级" :value="13"></el-option>
        <el-option label="高级" :value="14"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="所属机构:" prop="orgCode" v-if="loginOrgCode != 'blcuonline'">
      <el-select placeholder="" size="small" placeholder="机构" v-model="form.orgCode" @change="changeOrgCode">
        <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="主讲老师:" prop="lecturer">
      <el-select v-model="form.lecturer"
                 multiple
                 filterable
                 style="width: 100%;"
                 placeholder="请选择">
        <el-option
            v-for="item in teacherList"
            :key="item.teacherId"
            :label="item.teacherName"
            :value="item.teacherId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="试听视频:" prop="auditionVideoPath">
      <div v-show="uploadMethodDataType == 1">
        <el-upload
            :action="uploadURL"
            ref="auditionVideo"
            :on-remove="auditionVideoHandleRemove"
            :on-change="auditionVideoOnChange"
            :on-success="auditionVideoHandleSuccess"
            :before-upload="auditionVideoBeforeAvatarUpload"
            :limit="1"
            :file-list="auditionVideoFileList"
            :show-file-list="true"
            :auto-upload="false"
            style="width: 50%"
            :class="{'avatar-video': true, 'hide': hideAuditionVideoUpload}"
        >
          <el-button slot="trigger" size="small" ref="selectFile" @click="uploadMethod(1)" type="primary">选取文件</el-button>
          <el-button type="primary" size="small"  @click="uploadMethod(2)" style="margin-left: 10px;" class="but-cls">填写链接</el-button>
          <div v-show="uploadMethodData == 1">
            <div slot="tip" class="el-upload__tip">建议MP4格式，视频不宜太大</div>
            <video controls="controls" style="display: none" id="aa" @canplaythrough="videoDuration(this)">
            </video>
            <el-progress :percentage="percent" status="success"></el-progress>
          </div>
        </el-upload>
      
        <div v-show="uploadMethodData == 2">
          <el-form-item label="视频名称:" prop="pathName">
            <el-input v-model="pathName" placeholder="视频名称" style="width: 50%; margin-bottom: 10px;"></el-input>
          </el-form-item>
        
          <el-form-item label="视频链接:" prop="videoPath">
            <el-input v-model="videoPath" placeholder="视频链接" style="width: 50%; margin-bottom: 10px;"></el-input>
          </el-form-item>
          <el-form-item align="center">
            <el-button type="primary" size="small" @click="confirmUpload()" class="but-cls">确定上传</el-button>
          </el-form-item>
        </div>
        <el-dialog :visible.sync="dialogAuditionVideo" size="tiny" align="center">
      
        </el-dialog>
      </div>
      <div v-show="uploadMethodDataType == 2">
        <div v-show='!isRtmp'>
          <video controls="controls" :src="videoSrc" @canplaythrough="videoDuration(this)" style="width: 50%">
          </video>
        </div>
        <div v-show='isRtmp'>
          <object v-bind:data="rtmpParam.data" type="application/x-shockwave-flash" width="500" height="300" id="player">
            <param name="movie" v-bind:alue="rtmpParam.movie">
            <param name="wmode" value="transparent">
            <param name="allowFullScreen" value="true">
            <param name="allowScriptAccess" value="always">
          </object>
        </div>
        <el-button type="primary" size="small" @click="reUpload()" class="but-cls" style="margin-left: 10px">
          重新上传
        </el-button>
      </div>
    </el-form-item>
    <el-form-item label="课程封面:" prop="picturePath">
      <el-upload
          v-model="form.picturePath"
          :class="{'hide': hidePictureUpload}"
          :action="uploadURL"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="pictureHandleRemove"
          :on-change="pictureOnChange"
          :on-success="pictureHandleSuccess"
          :on-error="onError"
          :before-upload="pictureBeforeAvatarUpload"
          :limit="1"
          :on-exceed="exceed"
          :file-list="pictureFileList"
          :show-file-list="true"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" size="tiny">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </el-form-item>
    <el-form-item label="是否显示:" prop="isView">
      <el-radio v-model="form.isView" :label="1">显示</el-radio>
      <el-radio v-model="form.isView" :label="0">不显示</el-radio>
    </el-form-item>
    <el-form-item label="是否打包套餐:" prop="isPacking">
      <el-radio v-model="form.isPacking" :label="1">打包</el-radio>
      <el-radio v-model="form.isPacking" :label="0">不打包</el-radio>
    </el-form-item>
    <el-form-item label="自营排序:" prop="sort" v-if="orgType == 1">
      <el-input v-model="form.sort" placeholder="排序"></el-input>
    </el-form-item>
    <el-form-item label="机构排序:" prop="orgSort" v-if="showOrgCC">
      <el-input v-model="form.orgSort" placeholder="排序"></el-input>
    </el-form-item>
    <el-form-item label="咨询方式:" prop="contactInfo">
      <el-input v-model="form.contactInfo" placeholder="请输入QQ号码"></el-input>
    </el-form-item>
    
    <el-form-item align="center">
      <el-button type="primary" @click="saveAndNext(1)">保存，进入下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import commodityModel from './commodityModel';
  import Base64 from '@/api/video/lib/base64.js';
  import Crypto from 'crypto-js';
  import OSS from 'ali-oss';
  import alioss from '@/api/video/ali-oss.js';
  
  
  export default {
    name: 'step1',
    components: {commodityModel},
    props: {
      form: {
        type: Object,
        default: {}
      },
      rules: {
        type: Object,
        default: {}
      },
      
    },
    data() {
      
      return {
        showOrgCC: false,
        orgType: '',
        org: [],
        modelTypeList: [],
        teacherList: [],
        selectedCategory: [],
        loginOrgCode: '',
        categoryOptions: [],
        selectedCategory: [],
        uploadMethodDataType: '1',
        hideAuditionVideoUpload: false,
        uploadURL: '',
        isRtmp: false,
        rtmpParam: {
          data: '',
          movie: ''
        },
        videoSrc: '',
        dialogAuditionVideo: false,
        videoPath: '',
        videoSrc: '',
        pathName: '',
        uploadMethodData: '1',
        percent: 0,
        auditionVideoFileList: [],
        video: {
          videoInfoId: '',
          videoInfoName: '',
          duration: '',
          bak2: ''
        },
        hidePictureUpload: false,
        dialogImageUrl: '',
        dialogVisible: false,
        pictureFileList: [],
        options: {
          img: '',                         //裁剪图片的地址
          info: true,                      //裁剪框的大小信息
          outputSize: 1,                   // 裁剪生成图片的质量
          outputType: 'jpeg',              //裁剪生成图片的格式
          canScale: false,                 // 图片是否允许滚轮缩放
          autoCrop: true,                  // 是否默认生成截图框
          autoCropWidth: 160,              // 默认生成截图框宽度
          autoCropHeight: 90,             // 默认生成截图框高度
          fixed: false,                    //是否开启截图框宽高固定比例
          fixedNumber: [16, 9]              //截图框的宽高比例
        },
      }
    },
    
    methods: {
      saveAndNext(val) {

        this.$emit("changeStep","next",val);
        
        /*let params = this.form;
        let lecturers = JSON.parse(JSON.stringify(this.form.lecturer));
        let lecturer = [];
        for (let i in lecturers) {
          let l = {
            lecturer: lecturers[i]
          };
          lecturer.push(l);
        }
        let flag = true;
        if(this.selectedCategory instanceof Array) {
          if(this.selectedCategory.length > 0) {
            this.form.ccId = this.selectedCategory[this.selectedCategory.length-1];
          }
        } else {
          this.form.ccId = this.selectedCategory;
        }
        if(this.selectedOrgCategory.length > 0) {
          this.form.orgCcId = this.selectedOrgCategory[this.selectedOrgCategory.length-1];
        }
        if(this.loginOrgCode == 'blcuonline') {
          this.form.ccId = this.form.orgCcId;
        }
        this.form.commodityLecturerList = lecturer;
        let url = '/commodityInfo/saveCommodity';
        this.$refs['courseForm'].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            flag = false;
          }
        });
        if (this.form.validityType == 1) {
          this.form.validity = -1;
        }
        else if(this.form.validity==''){
          this.$message.error('请输入有效期');
          flag = false;
        }
        if (this.form.openClassType == 1) {
          this.form.openClassTime = new Date(0);
        }

        if (flag) {
          this.https.fetchPost(url, params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              if (!this.form.commodityId) {
                this.form.commodityId = data.data.data;
              }
              this.$emit("changeStep",val);

            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }

          }).catch(err => {
                console.log(err);
                this.$message.error('网络错误');
              }
          );

        }*/
        
      },
      changeCategory(value) {
        console.log(value);
      },
      changeValidityType(val) {
        console.log(val);
        if(val == 1) {
          this.form.validity = '';
          this.form.validityType=1;
          this.$refs.courseForm.clearValidate('validity');
        } else {
          this.form.validityType=2;
          this.form.validity = '';
        }

      },
      checkValidity(value){
        this.form.validityType = 2;
      },
      changeOpenClass(val) {
        if (val == 1) {
          this.form.openClassTime = new Date();
        } else {
          this.form.openClassType = 2;
        }
      },
      searchCommodityinfoByAll(){//获取课程信息
        this.selectedCategory='';
        let params = {
          all: this.form.courseName
        };
        this.https.fetchPost('/commodityInfo/searchCommodityinfoByAll', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let commodityData = data.data.data;
            let commodityIds = [];
            if(commodityData){
              commodityIds.push(commodityData.ccId);
              console.log(commodityIds);
              this.selectedCategory=commodityData.ccId;
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      loadCourseCategory() {
        let params = {
          orgCode: this.$store.state.eblcuOrg
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.categoryOptions = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      changeOrgCode(val) {
        if(val ==this.$store.state.eblcuOrg) {
          this.showOrgCC = false;
        } else {
          this.showOrgCC = true;
        }
        this.teacherData = [];
        this.form.lecturer = [];
        this.searchTeacher(val);
        this.selectCategoryData(val);

        // this.searchCourseType();
      },
      searchTeacher(val) {
        ///managerTeacher/getOrganizationList
        let params = {
          orgCode: val
        };
        this.https.fetchGet('/managerTeacher/getOrganizationList', params).then((data) => {
          let code = data.data.code;
          if (code == 200) {
            this.teacherList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      selectCategoryData(val) {
        if(val == this.$store.state.eblcuOrg) {
          this.showOrgCC = false;
          this.selectedOrgCategory = [];
          return;
        } else {
          this.showOrgCC = true;
        }
        //http://localhost:8080/news/index
        if(val == undefined) {
          val = '';
        }
        let params = {
          orgCode: val
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          this.categoryOrgOptions = [];
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data != null) {
              this.categoryOrgOptions = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      auditionVideoBeforeAvatarUpload(file) {
        let params = {
          extendName: 'mp4',
          videoName: '123'
        };
        // this.uposs(d,file);
        this.https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            this.video.videoInfoId = data.data.data.videoInfoId;
            this.uposs(data.data.data, file);
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );
        return false;
      },
      auditionVideoHandleSuccess(response) {
        this.auditionVideoFileList = [];
        this.form.auditionVideoPath = response.data.fileId;
        let file = {
          name: '123.png',
          url: response.data.filePath
        };
        this.auditionVideoFileList.push(file);

      },
      auditionVideoOnChange(file, fileList) {
        let fileName = file.name;
        let extendName = fileName.substr(file.name.lastIndexOf('.') + 1);
        let videoName = fileName.substr(0, file.name.lastIndexOf('.'));
        if (extendName == 'mp4') {
          if (!this.autoIsUpload) {
            this.autoIsUpload = true;
            this.submitUpload();
          }
          console.log(extendName);
        } else {
          this.$message({
            type: 'info',
            message: '只能上传mp4格式视频！'
          });
          this.$refs.auditionVideo.clearFiles;
          this.auditionVideoFileList = [];
        }

      },
      auditionVideoHandleRemove(file, fileList) {
        this.form.auditionVideoPath = '';
        this.$refs.auditionVideo.clearFiles;
        this.auditionVideoFileList = [];
        this.percent = 0;
        this.autoIsUpload = false;
        //this.hideAuditionVideoUpload = fileList.length >= this.auditionVideoLimitCount;
      },
      uploadMethod(val) {
        this.uploadMethodData = val;
      },
      submitUpload() {
        let uploadFiles = this.$refs.auditionVideo.uploadFiles;
        if (uploadFiles.length != 1) {
          this.$message({
            type: 'info',
            message: '只能上传一个试听视频'
          });
          return;
        }

        let file = uploadFiles[0].raw;
        let extendName = file.name.substr(file.name.lastIndexOf('.') + 1);
        let videoName = file.name.substr(0, file.name.lastIndexOf('.'));
        let fileSize = file.size;
        let params = {
          extendName: extendName,
          videoName: videoName
        };
        this.https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.video.videoInfoId = data.data.data.videoInfoId;
            this.video.videoInfoName = data.data.data.videoName;
            this.video.bak2 = fileSize;
            this.uposs(data.data.data, file);
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );
      },

      uposs(obj, file) {
        var accesskey = obj.accesskeysecret;
        let key = obj.keyWord;
        var accessKeyId = obj.accesskeyid;
        var stsToken = obj.securitytoken;
        var videoInfoId = obj.videoInfoId;
        var urlfile = URL.createObjectURL(file);
        document.getElementById('aa').src = urlfile;
        var policyText = {
          'expiration': '2020-01-01T12:00:00.000Z', //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
          'conditions': [
            ['content-length-range', 0, 10485760000] // 设置上传文件的大小限制
          ]
        };

        var policyBase64 = Base64.Base64.encode(JSON.stringify(policyText));
        var message = policyBase64;
        var bytes = Crypto.HmacSHA1(message, accesskey);
        let signature = bytes.toString(Crypto.enc.Base64);

        console.log(signature);

        let ossClient = new OSS({
          'region': 'oss-cn-beijing',
          'accessKeyId': accessKeyId, //1111
          'accessKeySecret': accesskey,
          'stsToken': stsToken, //1111
          'bucket': 'openbj',
          'endpoint': 'https://oss-cn-beijing.aliyuncs.com',
          'policy': policyBase64,
          'success_action_status': '200', //让服务端返回200,不然，默认会返回204
          'signature': signature
        });

        console.log(obj);
        let abort = false; //进度条显示
        let checkpoint_temp = true;
        let result = alioss.multitest(ossClient, file, checkpoint_temp, this.multiSuccess, '', this.uploadProgress, key);

      },
      videoDuration(ele) {
        let duration = document.getElementById('aa').duration;
        this.video.duration = duration;
      },

      uploadProgress(percent) {
        this.percent = percent * 100;
      },

      multiError() { //上传失败
        console.log('上传失败,请重新上传', 'error');
      },

      multiSuccess(result) {
        if (result) {
          if (result.res.status == 200) {
            let params = {
              videoInfoId: this.video.videoInfoId,
              videoInfoName: this.video.videoInfoName,
              bak2: this.video.bak2,
              duration: parseInt(this.video.duration)
            };
            this.https.fetchPost('/file/saveVideoPlayUrl', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.videoSrc = data.data.data.url;
                this.form.auditionVideoPath = data.data.data.videoInfoId;
                this.selectPlayer();
                this.uploadMethodDataType = 2;
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                  console.log(err);
                }
            );
          }
        }
      },
      selectPlayer() {
        let url = this.videoSrc;
        this.isRtmp = false;
        if (url.indexOf('rtmp://live.teblcu.com') >= 0) {
          this.isRtmp = true;
          let urls = url.split('/mp4:');
          let url1 = urls[0];
          let mediaURL = urls[1];
          this.parm(url1, mediaURL);
          // data this.src+this.getVersion()+this.parm()
          this.rtmpParam.data = this.src + this.version + this._parm;
          this.rtmpParam.movie = this.src + this.version + this._parm;
        }
      },
      reUpload() {
        this.auditionVideoHandleRemove();
        this.videoSrc = '';
        this.videoPath = '';
        this.pathName = '';
        this.uploadMethodDataType = 1;
      },
      confirmUpload() {
        if (this.videoPath == '') {
          this.$message({
            type: 'info',
            message: '视频链接不能为空！'
          });
          return;
        }
        let params = {
          pathName: this.pathName,
          path: this.videoPath
        };
        this.https.fetchPost('/file/upload_path', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.form.auditionVideoPath = data.data.data.fileId;
            this.videoSrc = this.videoPath;
            this.uploadMethodDataType = 2;
            this.selectPlayer();
            this.$message({
              type: 'success',
              message: '上传成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );

      },

      exceed(res, file) {
        console.log(res);
      },
      pictureBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });
        return isJPG && isLt2M && isSize;
      },
      onError () {
      },
      pictureHandleSuccess(response, file, fileList) {
        this.pictureFileList = [];
        if(response.code == 200) {
          this.form.picturePath = response.data.fileId;
          let file = {
            name: response.data.filePath,
            url: response.data.filePath
          };
          this.pictureFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }

      },
      pictureOnChange(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },

      pictureHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },

      handlePictureCardPreview(file) {
        console.log(file.url);
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
      this.orgType = this.$store.state.orgType;
      this.loadCourseCategory();
      this.selectOrg();
    }
  };
</script>

<style scoped>

</style>